module.exports = __webpack_public_path__ + "img/hw-bg3.5ba7667e.png";